// blog24.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg"; // hero background
import detailImg from "../Asets/blog2424.png"; // detail image for blog 24
import Header from "../components/header";
import Footer from "../components/footer";

const Blog24 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog / Emotional Intelligence in Preschool</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Why Emotional Intelligence Begins in Preschool | Best Preschool in Harni, Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 17 November 2025</div>
          <br />

          <img
            src={detailImg}
            alt="Why Emotional Intelligence Begins in Preschool | Best Preschool in Harni, Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">

            <p>
              In today’s world, education is more than learning ABCs and numbers — 
              it’s about helping children understand emotions, communicate better, 
              and build meaningful relationships. This important ability is known 
              as <strong>Emotional Intelligence (EI)</strong>, and it starts developing 
              during early childhood, especially in preschool.
            </p>

            <p>
              At <strong>Red School House Vadodara</strong>, proudly known as the 
              <strong> best preschool in Harni, Vadodara</strong>, emotional intelligence 
              is not an extra activity — it is part of daily learning. Children grow 
              emotionally and socially, becoming kind, confident, and aware of themselves 
              and others.
            </p>

            <hr />

            <h3>What Is Emotional Intelligence?</h3>
            <p>Emotional Intelligence means a child can:</p>

            <ul>
              <li>Understand their own feelings</li>
              <li>Recognize emotions in others</li>
              <li>Stay calm in different situations</li>
              <li>Work well with friends</li>
              <li>Express emotions in a healthy way</li>
            </ul>

            <p>
              At the best preschool in Harni, Vadodara, children learn emotional skills 
              through stories, interaction, activities, and guided conversations.
            </p>

            <hr />

            <h3>Why EI Starts in Preschool</h3>
            <p>
              Preschool is often a child’s first structured environment outside their home. 
              This makes it the best place to learn emotional control and social skills.
            </p>

            <p>Children at Red School House Vadodara learn to:</p>

            <ul>
              <li>Share toys and space with others</li>
              <li>Resolve small conflicts</li>
              <li>Express their feelings</li>
              <li>Understand what friendship means</li>
              <li>Build patience and empathy</li>
            </ul>

            <p>
              Because emotions are strong at this age, early guidance builds lifelong emotional strength.
            </p>

            <hr />

            <h3>The Role of Teachers at the Best Preschool in Harni, Vadodara</h3>
            <p>
              Teachers at Red School House are not just educators — they are emotional mentors.
            </p>

            <p>They help children understand feelings through:</p>

            <ul>
              <li>Storytelling with emotional lessons</li>
              <li>Daily reflection activities (“How did you feel today?”)</li>
              <li>Group games that build teamwork</li>
              <li>Role-play sessions to build empathy</li>
              <li>Positive communication and behavior examples</li>
            </ul>

            <p>
              This approach is why Red School House is considered the best preschool in Harni, Vadodara.
            </p>

            <hr />

            <h3>How Emotional Intelligence Helps Children Grow</h3>
            <ul>
              <li><strong>Better focus:</strong> Children who manage emotions stay attentive.</li>
              <li><strong>Healthy friendships:</strong> EI helps children form strong bonds.</li>
              <li><strong>Confidence:</strong> Expressing emotions builds self-esteem.</li>
              <li><strong>Leadership qualities:</strong> Empathy and communication shape young leaders.</li>
            </ul>

            <p>
              At Red School House Vadodara, every activity — from music to outdoor play —
              supports emotional growth.
            </p>

            <hr />

            <h3>Creating an Emotionally Safe Environment</h3>
            <p>
              Children grow only when they feel safe, heard, and valued. 
              Red School House Vadodara provides a warm, nurturing environment 
              where children freely express their thoughts and emotions.
            </p>

            <p>
              This emotional safety builds trust between teachers and children 
              and encourages confident communication.
            </p>

            <hr />

            <h3>Contact Details</h3>
            <p>
              📍 <strong>Address:</strong> A-25, Castle White, Opp. Main Harni Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              📞 <strong>Phone:</strong> <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              📧 <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">redschoolhousebaroda2025@gmail.com</a>{" "}
              | <a href="mailto:redschoolhousebaroda@gmail.com">redschoolhousebaroda@gmail.com</a>
              <br />
              🌐 <strong>Website:</strong>{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
            </p>

            <p className="blog-tags">
              #RedSchoolHouseVadodara &nbsp; 
              #BestPreschoolInHarni &nbsp; 
              #EmotionalIntelligence &nbsp; 
              #ChildDevelopment &nbsp; 
              #VadodaraPreschools
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog24;
